export function getAddButtons(app) {
    const AddButtons = document.getElementsByClassName('eon-add-wishlist-btn');
    const PdfButtons = document.getElementsByClassName('eon-print-info-btn');
    const CallbackChange = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (
                mutation.type !== "attributes" ||
                !['data-color-code', 'data-artnr'].includes(mutation.attributeName)
            ) {
                return
            }
            app.onChangeControl(mutation.target)
            app.setSingleItem(mutation.target.getAttribute("data-artnr"), mutation.target.getAttribute("data-color-code"))
        }
    }
    const observer = new MutationObserver(CallbackChange)
    for (const btn of Object.values(PdfButtons)) {
        observer.observe(btn, {attributes: true})
        const col = btn.getAttribute("data-color-code");
        const article_nr = btn.getAttribute("data-artnr");
        app.setSingleItem(article_nr, col)
        if (btn.isWishlistEventListenerRegistered) continue;
        btn.addEventListener("click", function (e) {
            e.preventDefault()
            app.generatePdfSingle(article_nr, col)
        })
        btn.isWishlistEventListenerRegistered = true;
    }
    for (const btn of Object.values(AddButtons)) {
        app.onChangeControl(btn);
        observer.observe(btn, {attributes: true});
        if (btn.isWishlistEventListenerRegistered) continue;
        btn.addEventListener("click", function (e) {
            e.preventDefault()
            const col = this.getAttribute("data-color-code");
            const article_nr = this.getAttribute("data-artnr");
            if (col === undefined || article_nr === undefined) {
                console.error('Wishlist Button is missing data-attributes')
                return
            }
            if (this.isInWishlist) {
                app.removeFromWishlistOnClick(this, article_nr, col)
            } else {
                app.addToWishlistOnClick(this, article_nr, col)
            }
        });
        btn.isWishlistEventListenerRegistered = true;
    }

    return AddButtons
}

